<a [attr.aria-label]="label || text" role="button" class="btn button-monsido-icon text-right" (click)="onCallback()">
    <div class="page-count">{{ parseModel() | monNumber }}</div>
    <div class="page-text">{{ ((parseModel() === 1 ? text : textPlural) || '') | translate}}</div>
</a>
